import { render, staticRenderFns } from "./CabecalhoAnuencia.vue?vue&type=template&id=0339f760&scoped=true"
import script from "./CabecalhoAnuencia.vue?vue&type=script&lang=js"
export * from "./CabecalhoAnuencia.vue?vue&type=script&lang=js"
import style0 from "./CabecalhoAnuencia.vue?vue&type=style&index=0&id=0339f760&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0339f760",
  null
  
)

export default component.exports